import { UserModel } from '@/models/UserModel';

export const getDefaultScreenerFacilityId = (
  user: UserModel
): string | null => {
  const accesses = user.user_facility_accesses ?? [];
  const isAccessible = (facilityId?: string | null) =>
    !!facilityId &&
    accesses.some((access) => access.facility_id === facilityId);

  if (isAccessible(user.default_screener_facility_id)) {
    return user.default_screener_facility_id!;
  }
  return isAccessible(user.facility_id)
    ? user.facility_id
    : (accesses[0]?.facility_id ?? null);
};
